import { useCallback } from 'react';

import {
  type BoardsListOptions,
  type ClipAndBoardListItem,
  type ListResponse,
  type SortDirection,
  type ViewField,
} from '@air/api/types';

import { usePublicBoardsFetcher } from '~/swr-hooks/gallery/galleryView/usePublicBoardsFetcher';

export const usePublicTableViewBoardsDataFetcher = () => {
  const { publicBoardsFetcher } = usePublicBoardsFetcher();

  const publicTableViewBoardsDataFetcher = useCallback(
    async ({
      params,
      sortFieldName,
      sortDirection,
      shortId,
      parentId,
      cursor,
      collectionId,
    }: {
      cursor: string | null;
      shortId: string;
      parentId: string;
      params: Partial<BoardsListOptions>;
      sortFieldName: ViewField['name'];
      sortDirection: SortDirection;
      /** See `usePublicBoardsFetcher` — absent outside a collection sub-page drill. */
      collectionId?: string;
    }): Promise<ListResponse<ClipAndBoardListItem>> => {
      const { pagination, data, total } = await publicBoardsFetcher({
        shortId,
        parentId,
        params,
        sortFieldName,
        sortDirection,
        cursor,
        collectionId,
      });

      return {
        data: data.map((board) => ({
          id: board.id,
          type: 'board',
          data: board,
        })),
        total,
        pagination,
      };
    },
    [publicBoardsFetcher],
  );

  return {
    publicTableViewBoardsDataFetcher,
  };
};
